
 import { authenticatedFetch } from "../Auth/Auth";
 import { getCurrentConfig } from '../../config/config';
 
 const config = getCurrentConfig();

export const addContact = async (addcontactJSONbody) => {
   
 
    const response = await authenticatedFetch(`${config.API_BASE_URL}/contacts`, {
        method: 'POST',
        headers: {
        
          'Content-Type': 'application/json',
          'User-Agent': 'agentApp/1.0',
        },
        body: JSON.stringify(addcontactJSONbody)
      });
      
      if (response.ok) {
        const responseData = await response.json();
        return responseData;
      } else {
        throw new Error(`Error adding contact`);
      }




};